export enum ProductObtainType {
  PRODUCED = 'produced',
  PURCHASED = 'purchased',
  RECYCLE_LOST = 'recycle_lost',
  RECYCLE_GAINED = 'recycle_gained',
}
